(() => {
  const root = document.querySelector('[data-digestive-page]');
  if (!root) return;
  const image = root.querySelector('[data-dg-main]');
  const thumbs = [...root.querySelectorAll('[data-dg-thumb]')];
  let index = 0, request = 0;
  const select = async next => {
    if (!thumbs.length) return;
    index = (next + thumbs.length) % thumbs.length;
    const target = thumbs[index], token = ++request, preload = new Image();
    preload.src = target.dataset.src;
    image?.setAttribute('data-loading', '');
    try { await preload.decode(); } catch { image?.removeAttribute('data-loading'); return; }
    if (token !== request || !image) return;
    image.src = preload.src;
    image.srcset = target.dataset.smallSrc ? `${target.dataset.smallSrc} 600w, ${preload.src} 1200w` : '';
    image.alt = target.dataset.alt;
    const imageNote = root.querySelector('[data-dg-image-note]');
    if (imageNote) imageNote.hidden = target.dataset.illustrative !== 'true';
    image.removeAttribute('data-loading');
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) image.animate([{ opacity: .5 }, { opacity: 1 }], { duration: 160 });
    thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
    const track = target.parentElement;
    track.scrollLeft = target.offsetLeft - track.offsetLeft - (track.clientWidth - target.offsetWidth) / 2;
    root.querySelector('[data-dg-status]').textContent = `Image ${index + 1} of ${thumbs.length}`;
  };
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => select(i)));
  root.querySelector('[data-dg-prev]')?.addEventListener('click', () => select(index - 1));
  root.querySelector('[data-dg-next]')?.addEventListener('click', () => select(index + 1));
  root.querySelector('[data-dg-gallery]')?.addEventListener('keydown', event => {
    const next = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: thumbs.length - 1 }[event.key];
    if (next === undefined) return;
    event.preventDefault(); select(next);
  });
  let pointer;
  image?.addEventListener('pointerdown', event => { pointer = { x: event.clientX, y: event.clientY }; });
  image?.addEventListener('pointerup', event => {
    if (!pointer) return;
    const x = event.clientX - pointer.x, y = event.clientY - pointer.y; pointer = null;
    if (Math.abs(x) > 42 && Math.abs(x) > Math.abs(y) * 1.2) { event.preventDefault(); select(index + (x < 0 ? 1 : -1)); }
  });
  image?.addEventListener('pointercancel', () => { pointer = null; });
  image?.addEventListener('dragstart', event => event.preventDefault());
  if (image) image.style.touchAction = 'pan-y';
  const form = root.querySelector('form[action*="cart/add"]');
  const selectedPlanId = () => {
    if (form?.querySelector('input.sls-option[data-type="one_time"]:checked')) return '';
    const interval = form?.querySelector('select[name="subs_interval"]');
    return interval?.disabled ? interval.value : form?.querySelector('[name="selling_plan"]')?.value || '';
  };
  const variantData = root.querySelector('[data-dg-variants]');
  const variants = variantData ? JSON.parse(variantData.textContent) : [];
  const packs = [...root.querySelectorAll('[data-dg-pack]')];
  let variant = variants.find(item => String(item.id) === form?.elements.id?.value);
  const offerReady = form?.closest('product-form-component')?.dataset.dgOfferReady === 'true';
  let syncBundleSubscriptionCadence = () => {};
  if (form) import('@theme/bundle-subscription-cadence').then(module => {
    syncBundleSubscriptionCadence = module.syncBundleSubscriptionCadence;
    renderOffer();
  });
  const renderOffer = () => {
    if (!variant || !form) return;
    syncBundleSubscriptionCadence(root, { dataset: {
      bundleQuantity: String(variants.indexOf(variant) + 1),
      bundleVariantId: String(variant.id),
    } });
    const planId = selectedPlanId();
    const allocation = variant.plans.find(item => String(item.id) === planId);
    const activePrice = allocation?.price ?? variant.price;
    const money = allocation?.money ?? variant.money;
    const ready = offerReady && variant.available && activePrice > 0;
    const button = form.querySelector('[name="add"]');
    if (button) button.disabled = !ready;
    const label = form.querySelector('[data-dg-add-label]');
    if (label) label.textContent = ready ? `Add to cart · ${money}` : 'Not available to order yet';
    const status = root.querySelector('[data-dg-offer-status]');
    if (status) status.textContent = ready ? '' : 'Explore the formula while ordering is unavailable.';
    // A pack is one supplier-bound unit in Shopify; never multiply its quantity.
    form.elements.quantity.value = '1';
    const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: variants[0]?.currency || 'USD' }).format(cents / 100);
    packs.forEach(pack => {
      const item = variants.find(entry => String(entry.id) === pack.dataset.dgPack);
      pack.setAttribute('aria-pressed', String(item?.id === variant.id));
      const matchingPlan = item?.plans.find(entry => String(entry.id) === planId);
      const shown = matchingPlan?.price ?? item?.price ?? 0;
      pack.querySelector('[data-dg-pack-price]').textContent = shown > 0 ? (matchingPlan?.money ?? item.money) : '';
      const bottleCount = variants.indexOf(item) + 1;
      const each = pack.querySelector('[data-dg-pack-each]');
      if (each) each.textContent = formatMoney(Math.round(shown / bottleCount)) + ' / each';
      const compare = pack.querySelector('[data-dg-pack-compare]');
      if (compare) {
        const comparison = variants[0].price * bottleCount;
        compare.textContent = formatMoney(comparison);
        compare.hidden = comparison <= shown;
      }
    });
  };
  const choosePack = id => {
    const next = variants.find(item => String(item.id) === String(id));
    if (!next || !form) return;
    variant = next;
    form.elements.id.value = String(next.id);
    // Horizon prioritizes the URL variant when serializing its native form.
    const url = new URL(location.href); url.searchParams.set('variant', String(next.id));
    history.replaceState(history.state, '', url);
    renderOffer();
  };
  packs.forEach(pack => pack.addEventListener('click', () => choosePack(pack.dataset.dgPack)));
  packs.forEach((pack, packIndex) => pack.addEventListener('keydown', event => {
    const next = {ArrowRight:packIndex+1, ArrowDown:packIndex+1, ArrowLeft:packIndex-1, ArrowUp:packIndex-1, Home:0, End:packs.length-1}[event.key];
    if (next === undefined) return;
    event.preventDefault();
    const target = packs[(next + packs.length) % packs.length];
    target.focus(); choosePack(target.dataset.dgPack);
  }));
  let offerTimer;
  const scheduleOffer = () => { clearTimeout(offerTimer); offerTimer = setTimeout(renderOffer, 0); };
  form?.addEventListener('change', scheduleOffer);
  form?.addEventListener('click', event => {
    if (!event.target.closest('.sealsubs-target-element')) return;
    scheduleOffer();
    setTimeout(renderOffer, 150);
  });
  for (const name of ['sealsubs:subscription_widget_created', 'sealsubs:selling_plan_changed', 'sealsubs:price_update']) {
    document.addEventListener(name, scheduleOffer);
  }
  if (form) new MutationObserver(mutations => {
    if (mutations.some(mutation => mutation.target.matches?.('[name="selling_plan"]') ||
      [...mutation.addedNodes].some(node => node.nodeType === 1 &&
        (node.matches('[name="selling_plan"]') || node.querySelector('[name="selling_plan"]'))))) scheduleOffer();
  }).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  renderOffer();
  form?.addEventListener('submit', event => {
    const allocation = variant?.plans.find(item => String(item.id) === selectedPlanId());
    if (!offerReady || !variant?.available || (allocation?.price ?? variant?.price ?? 0) <= 0) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  form?.addEventListener('formdata', event => {
    event.formData.set('quantity', '1');
    if (variant) event.formData.set('id', String(variant.id));
    const planId = selectedPlanId();
    if (planId && variant?.plans.some(item => String(item.id) === planId)) event.formData.set('selling_plan', planId);
    else event.formData.delete('selling_plan');
  });
  const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];
  const incoming = new URL(location.href).searchParams;
  root.querySelectorAll('[data-dg-product-link]').forEach(link => {
    const url = new URL(link.href, location.href);
    campaignKeys.forEach(key => { if (incoming.has(key)) url.searchParams.set(key, incoming.get(key)); });
    link.href = url.href;
  });
  const article = root.querySelector('[data-dg-article]'), sticky = root.querySelector('[data-dg-sticky]');
  if (article) {
    const update = () => {
      const wrapper = document.querySelector('.page-wrapper');
      const desktop = matchMedia('(min-width:990px)').matches && wrapper;
      const viewport = desktop ? wrapper.clientHeight : innerHeight;
      const offset = article.getBoundingClientRect().top - (desktop ? wrapper.getBoundingClientRect().top : 0);
      const fraction = Math.min(1, Math.max(0, -offset / Math.max(1, article.offsetHeight - viewport)));
      const progress = root.querySelector('[data-dg-progress]');
      if (progress) progress.style.width = `${fraction * 100}%`;
      if (sticky) sticky.hidden = !(article.querySelector('h2')?.getBoundingClientRect().top < viewport) || Boolean(root.querySelector('#digestive-offer')?.getBoundingClientRect().top < viewport && root.querySelector('#digestive-offer')?.getBoundingClientRect().bottom > 0);
    };
    document.addEventListener('scroll', update, { capture: true, passive: true });
    window.addEventListener('resize', update); window.addEventListener('pageshow', update); update();
  }
})();
